<template>
  <b-modal
    ref="bModal"
    :title="$t('archive.archiveLocation.selectArchiveLocation')"
    centered
    size="xs"
    modal-class="scan-location-modal"
    @hide="onHide"
  >
    <b-row class="px-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <div class="px-5 pb-3 pt-2 text-center d-flex flex-column">
          <i
            class="main-icon pb-3 far fa-scanner"
            aria-hidden="true"
          />
          <span class="title">{{ $t('archive.modal.scanHelp') }}</span>
        </div>
        <b-form-group
          class="barcode-input"
          :state="!errors.has(element.label)"
          :invalid-feedback="errors.first(element.label)"
        >
          <b-input-group
            size="sm"
            class="mb-2 mr-sm-2 mb-sm-0"
          >
            <b-input-group-prepend>
              <b-input-group-text>
                <fa-icon :icon="['fal', 'barcode-alt']" />
              </b-input-group-text>
            </b-input-group-prepend>
            <vt-input
              v-model="archivingLocation"
              v-validate="getLocationLabelValidationRules"
              class="form-control-sm"
              :data-vv-name="element.label"
              :data-vv-as="$t('archive.grid.archiveLocation')"
              :class="{'is-invalid': errors.has($tc('archive.grid.archiveLocation')) }"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="onSave"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { SUBPORTION_TYPES } from '@/api/resources/subportionTypes'
import { ArchiveHelper } from '@/modules/archiveModule/services/archiveHelper'

export default {
    name: 'ScanLocationModal',
    props: {
        entityType: { type: Object, required: true },
        entitySubtype: {
            type: String,
            required: false,
            validator: value => [
                PORTION_TYPES.PARAFFIN_BLOCK.key,
                PORTION_TYPES.FROZEN_BLOCK.key,
                SUBPORTION_TYPES.SLIDE.key
            ].includes(value)
        }
    },
    data() {
        return {
            element: {},
            archivingLocation: null,
            internalEntityType: null,
            internalEntitySubtype: null
        }
    },
    computed: {
        getLocationLabelValidationRules() {
            return ArchiveHelper.getLocationLabelValidationRules(this.internalEntityType, this.internalEntitySubtype)
        }
    },
    watch: {
        entityType(newValue) {
            if (newValue) {
                this.internalEntityType = newValue
            }
        },
        entitySubtype(newValue) {
            this.internalEntitySubtype = this._mapStringToEntitySubtypeObject(newValue)
        }
    },
    methods: {
        _mapStringToEntitySubtypeObject(subtypeString) {
            switch (subtypeString) {
            case PORTION_TYPES.PARAFFIN_BLOCK.key:
                return PORTION_TYPES.PARAFFIN_BLOCK
            case PORTION_TYPES.FROZEN_BLOCK.key:
                return PORTION_TYPES.FROZEN_BLOCK
            case SUBPORTION_TYPES.SLIDE.key:
                return SUBPORTION_TYPES.SLIDE
            default:
                return null
            }
        },
        show(element) {
            this.element = element
            this.archivingLocation = element.archivingLocation
            this.internalEntityType = this.entityType
            this.internalEntitySubtype = this._mapStringToEntitySubtypeObject(this.entitySubtype)
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onHide() {
            this.archivingLocation = null
        },
        async onSave() {
            const valid = await this.$validator.validateAll()
            if (!valid) {
                return
            }
            this.element.archivingLocation = this.archivingLocation
            this.$emit('archiving-location-updated', this.element)
            this.hide()
        }
    }
}

</script>

<style lang="scss">
    .scan-location-modal .main-icon {
        color: vt-color(primary);
        font-size: 25px;
    }
    .scan-location-modal .title {
        font-size: font-size(very-small) !important;
    }
    .scan-location-modal .modal-body {
        padding: 20px 10px;
    }
    .scan-location-modal .barcode-input {
        border: 1px solid vt-color(grid-general-border);
        border-radius: 5px;
        height: 32px;
        padding-top: 1px;
    }
    .scan-location-modal .input-group-prepend .input-group-text {
        border-radius: 14px;
        color: vt-color(search-bar-text);
        border: none;
        background-color: inherit;
        font-size: 12px;
        padding-left: 12px;
    }
    .scan-location-modal input {
        width: 150px;
        border: none;
        color: vt-color(search-bar-text);
        background-color: inherit;
        font-size:1.1rem;
        padding-top:0.4rem;
    }
</style>

<style lang="scss" scoped>
    .scan-location-modal span {
        font-size: font-size(very-normal);
    }
</style>
